import { API_ROOT } from "./conexion-urls";
import { debugLog } from "./debugHelper";
let baseURL = API_ROOT;


const fetchNoToken = (context, version, parent, endpoint, data, method = "GET") => {
  const url = `${baseURL}/${context}/${version}/${parent}/${endpoint}`;

  debugLog(":: fetch, fetchNoToken", { "url": url })

  if (method === "GET") {
    return fetch(url);
  } else {
    return fetch(url, {
      method,
      headers: {
        "Content-type": "application/json; charset=utf-8",

      },
      body: JSON.stringify(data),
    });
  }
};

const fetchNoTokenFile = (context, version, parent, endpoint, data, method = "GET") => {
  const url = `${baseURL}/${context}/${version}/${parent}/${endpoint}`;

  debugLog(":: fetch, fetchNoTokenFile", { "url": url })

  if (method === "GET") {
    return fetch(url);
  } else {
    return fetch(url, {
      method,



      body: data,
    });
  }
};

const fetchToken = (context, version, parent, endpoint, data, method = "GET") => {
  const url = `${baseURL}/${context}/${version}/${parent}/${endpoint}`;
  const token = localStorage.getItem("token") || "";

  //debugLog(":: fetch, fetchToken", { "url": url })

  if (method === "GET") {
    return fetch(url, {
      method,
      headers: {
        "x-token": token,
      },
    });
  } else {
    return fetch(url, {
      method,
      headers: {
        "Content-type": "application/json",

        "x-token": token,
      },
      body: JSON.stringify(data),
    });
  }
};

const fetchTokenFile = (context, version, parent, endpoint, data, method = "GET") => {
  const url = `${baseURL}/${context}/${version}/${parent}/${endpoint}`;
  const token = localStorage.getItem("token") || "";

  //debugLog(":: fetch, fetchTokenFile", { "url": url })

  if (method === "GET") {
    return fetch(url, {
      method,
      headers: {
        "x-token": token,
      },
    });
  } else {
    return fetch(url, {
      method,
      headers: {
        "x-token": token,
      },
      body: data,
    });
  }
};

const fetchTokenGETBody = (context, version, parent, endpoint, data, method = "GET") => {
  const url = `${baseURL}/${context}/${version}/${parent}/${endpoint}`;
  const token = localStorage.getItem("token") || "";

  //debugLog(":: fetch, fetchTokenGETBody", { "url": url })

  if (method === "GET") {
    return fetch(url, {
      method,
      headers: {
        "Content-type": "application/json",
        "x-token": token,
      },
      body: JSON.stringify(data),
    });
  } else {
    return fetch(url, {
      method,
      headers: {
        "Content-type": "application/json",

        "x-token": token,
      },
      body: JSON.stringify(data),
    });
  }
};

export { fetchNoToken, fetchToken, fetchNoTokenFile, fetchTokenFile, fetchTokenGETBody };
